import data from './guideTechnique.json';

export const GUIDE_BLOCKS = data.blocks;
export const GUIDE_FAQ = data.faq;

export default GUIDE_BLOCKS;
